import QrGeneration from "../components/QrGeneration";

const QrGenerator = () => {
    return (
        <div className="p-4">
            <QrGeneration text="https://example.com" />
        </div>
    );
};

export default QrGenerator;